import { useRequest } from 'ahooks';
import { Options } from 'ahooks/lib/useRequest/src/types';
import { isNil } from 'lodash-es';
import { useTranslate } from '@tolgee/react';
import { getRoleDetail } from 'services/api/assistant.account';
import { errorToasterWithServerMsg } from 'utils/errorToaster';

type TData = StoreHomeV2.RoleWithDepartment | undefined;
/**
 * 获取角色详情
 * @param roleId 角色id
 * @param options
 * @returns
 */
function useGetRoleDetail(roleId?: number, options?: Options<TData, number[]>) {
  const { t } = useTranslate();
  const request = useRequest<TData, number[]>(
    async () => {
      const data = await getRoleDetail(roleId!);
      return data;
    },
    {
      cacheKey: `@@useGetRoleDetail_${roleId}`,
      ready: !isNil(roleId),
      refreshDeps: [roleId],
      onError: (err) => {
        errorToasterWithServerMsg(err, t('department.获取角色详情失败，请稍后再试'));
      },
      ...options,
    },
  );
  return request;
}
export default useGetRoleDetail;
